var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.908 11.7148V23.9478H10.8323V11.7148H20.908ZM19.0188 4.375H12.7215L11.4621 5.5983H7.05396V8.0449H24.6864V5.5983H20.2783L19.0188 4.375ZM23.4269 9.2682H8.31341V23.9478C8.31341 25.2934 9.44693 26.3944 10.8323 26.3944H20.908C22.2934 26.3944 23.4269 25.2934 23.4269 23.9478V9.2682Z",
    fill: "#CB282E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconRed);
export default __webpack_public_path__ + "static/media/delete-icon-red.8fbe346af648827982cfe621b6f9ecd0.svg";
export { ForwardRef as ReactComponent };